import { Divider, useTheme } from '@mui/material';

import { CohortSummaryDetails, CohortSummaryAttributeResult } from '@verantos-dev/types-cohorts';

import CohortCharacteristicsTabularCategory from './CohortCharacteristicsTabularCategory';
import CohortCharacteristicsTabularRow from './CohortCharacteristicsTabularRow';
import { useCohortCharacteristicsTabularData } from '../hooks/useCohortCharacteristicsTabularData';

type CohortCharacteristicsTabularDataProps = {
  cohortSummaryData: CohortSummaryDetails;
  clinicalCharacteristicsDomainType?: string;
  customDisplayData?: CohortSummaryAttributeResult[];
  hasAnyCustomSelection?: boolean;
};

const CohortCharacteristicsTabularData = ({
  cohortSummaryData,
  clinicalCharacteristicsDomainType,
  customDisplayData,
  hasAnyCustomSelection,
}: CohortCharacteristicsTabularDataProps) => {
  const theme = useTheme();

  const rows = useCohortCharacteristicsTabularData({
    data: cohortSummaryData,
    clinicalCharacteristicsDomainType,
    customDisplayData,
    hasAnyCustomSelection,
  });

  return (
    <>
      {rows.map((row, index) => (
        <div key={row.id}>
          {row.category && <CohortCharacteristicsTabularCategory category={row.category} />}
          {!row.category && (
            <CohortCharacteristicsTabularRow name={row.name} value={row.value} index={index} />
          )}
          <Divider sx={{ borderColor: theme.palette.divider }} />
        </div>
      ))}
    </>
  );
};

export default CohortCharacteristicsTabularData;
